import React, { Component, Fragment } from 'react';

import Immutable from 'immutable';

import { Map, List, Record } from 'immutable';


import { BrowserRouter, Routes, Route } from "react-router-dom";

import AllPage from './pages/AllPage'



import CSVImport from './pages/CSVImport'

import ProjectPage from './pages/ProjectPage';

import ProductCheckPage from './pages/ProductCheckPage';
import ProductCheckPageOne from './pages/ProductCheckPageOne';
import ProductAllPage from './pages/ProductAllPage';

import StatusPage from './pages/StatusPage';


class MainComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: Map({
                contact: List()
            })


        }
    }
    componentDidMount() {

    }

    render() {

        return (

            <BrowserRouter>

                <Routes>
                    <Route exact path="/" element={<AllPage cognito={this.props.cognito} stage={this.props.stage} setStage={this.props.setStage} urls={this.props.urls} />} />
                    <Route path="/csv" element={<CSVImport cognito={this.props.cognito} stage={this.props.stage} setStage={this.props.setStage} urls={this.props.urls} />} />

                    <Route path="/project" element={<ProjectPage cognito={this.props.cognito} stage={this.props.stage} setStage={this.props.setStage} urls={this.props.urls} />} />


                    <Route path="/productall" element={<ProductAllPage cognito={this.props.cognito} stage={this.props.stage} setStage={this.props.setStage} urls={this.props.urls} />} />


                    <Route path="/product" element={<ProductCheckPage cognito={this.props.cognito} stage={this.props.stage} setStage={this.props.setStage} urls={this.props.urls} />} />
                    <Route path="/productone" element={<ProductCheckPageOne cognito={this.props.cognito} stage={this.props.stage} setStage={this.props.setStage} urls={this.props.urls} />} />
                    <Route path="/status" element={<StatusPage cognito={this.props.cognito} stage={this.props.stage} setStage={this.props.setStage} urls={this.props.urls} />} />



                </Routes>

            </BrowserRouter>

        );
    }
}

export default MainComponent;
